import * as R from 'ramda';
import React from 'react';

export const generalFieldTypes = [
  ['text', 'Text'],
  ['number', 'Number'],
  ['checkbox_list', 'Checkbox List'],
  ['select', 'Select'],
  ['bool', 'Bool'],
  ['files', 'Files'],
  ['textarea', 'Textarea'],
  ['date', 'Date'],
  ['descriptive_text', 'Descriptive Text'],
];

export const textFieldTypes = [
  ['text', 'Text'],
  ['textarea', 'Textarea'],
];

export const numberFieldTypes = [
  ['text', 'Text'],
  ['number', 'Number'],
  ['textarea', 'Textarea'],
];

export const checklistFieldTypes = [
  ['text', 'Text'],
  ['checkbox_list', 'Checkbox List'],
  ['textarea', 'Textarea'],
];

export const selectFieldTypes = [
  ['text', 'Text'],
  ['select', 'Select'],
  ['textarea', 'Textarea'],
];

export const booleanFieldTypes = [
  ['text', 'Text'],
  ['bool', 'Bool'],
  ['textarea', 'Textarea'],
];

export const filesFieldTypes = [
  ['files', 'Files'],
];

export const dateFieldTypes = [
  ['text', 'Text'],
  ['textarea', 'Textarea'],
  ['date', 'Date'],
];

export const descrtextFieldTypes = [
  ['descriptive_text', 'Descriptive Text'],
];

export const sectionTypeFieldMap = {
  product: [['product_ingredient', 'Product Ingredient']],
};

export const sectionTypeFields = R.compose(
  R.concat(generalFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeTextFields = R.compose(
  R.concat(textFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeNumberFields = R.compose(
  R.concat(numberFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeChecklistFields = R.compose(
  R.concat(checklistFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeSelectFields = R.compose(
  R.concat(selectFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeBooleanFields = R.compose(
  R.concat(booleanFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeFilesFields = R.compose(
  R.concat(filesFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeDateFields = R.compose(
  R.concat(dateFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const sectionTypeDescrTextFields = R.compose(
  R.concat(descrtextFieldTypes),
  R.propOr([], R.__, sectionTypeFieldMap),
);

export const renderOptions = ({ sectionType, value, question, questions }) =>
  ((value == 'text' || value == 'textarea') && questions.find(item=>item.uuid==question.uuid) != null ?
	  sectionTypeTextFields(sectionType).map(([type, label]) => (
		<option key={type} value={type}>
		  {label}
		</option>
	  ))
	: 
	   (value == 'number' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeNumberFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'checkbox_list' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeChecklistFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'select' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeSelectFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'bool' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeBooleanFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'files' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeFilesFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'date' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeDateFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  (value == 'descriptive_text' && questions.find(item=>item.uuid==question.uuid) != null) ?
		  sectionTypeDescrTextFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
		: 
		  sectionTypeFields(sectionType).map(([type, label]) => (
			<option key={type} value={type}>
			  {label}
			</option>
		  ))
	);

export const FieldTypeSelector = ({
  id,
  question,
  value,
  questions,
  handleChange,
  className,
  sectionType,
}) => (
  <select
    id={id}
    value={value}
    onChange={handleChange}
    className={className}
    required={true}
  >
    {renderOptions({ sectionType, value, question, questions})}
  </select>
);

export default FieldTypeSelector;
